import React, { ReactNode, useState } from 'react';
import { Box as Wrapper, Flex, Text, Collapse, Icon, ButtonBase } from '@tonic-ui/react';
import { useTranslation } from 'react-i18next';
import styles from './collapsible-content.module.css';

interface CollapsibleContentProps {
  header?: ReactNode;
  data: {
    id: string;
    heading: ReactNode;
    body: ReactNode;
  }[];
}

const CollapsibleContent = ({ header, data }: CollapsibleContentProps): JSX.Element => {
  const { t } = useTranslation();
  const [expandedId, setExpandedId] = useState<string>();
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const handleOnClick = (id: string) => {
    const nextExpanded = expandedId === id ? '' : id;
    setExpandedId(nextExpanded);
    setIsExpanded(nextExpanded !== '');
  };

  return (
    <Wrapper
      className={isExpanded ? styles.collapsible_content_expanded : styles.collapsible_content}
    >
      <Wrapper className={styles.collapsible_headings}>
        {header && <Flex mt="60px"> {header}</Flex>}
        <Flex
          direction="column"
          align="flex-start"
          style={{ verticalAlign: 'baseline' }}
          mt="50px"
          className={styles.collapsible_headings}
        >
          {data.map(({ id, heading }) => (
            <Text
              mb="6x"
              className={styles.content_link}
              onClick={() => handleOnClick(id)}
              key={`heading-${id}`}
            >
              {heading}
              <Icon
                icon="arrow-long-right"
                ml="2x"
                color="red:70"
                size="3x"
                className={styles.animated_arrow_right}
              />
            </Text>
          ))}
        </Flex>
      </Wrapper>
      <Wrapper className={styles.collapsible_body}>
        {data.map(({ id, body }) => (
          <Collapse key={`collapsible-content-${id}`} in={expandedId === id}>
            <Flex pt="5x" pb="5x" align="center">
              <ButtonBase onClick={() => handleOnClick(id)}>
                <Icon icon="arrow-left" mr="2x" color="red:70" size="3x" />
                <Text display="inline">{t('publicLandingPage.back')}</Text>
              </ButtonBase>
            </Flex>
            <Flex>{body}</Flex>
          </Collapse>
        ))}
      </Wrapper>
    </Wrapper>
  );
};

CollapsibleContent.displayName = 'CollapsibleContent';

export default CollapsibleContent;
